import { useEffect } from "react";
import { useGameState } from "../../context/GameRoomState";
import { useUser } from "../../context/UserContext";
import { useSessionStorage } from "../../hooks/useWebStorage";

export default function useHasPlayedRevolution() {
  const [has, setHas] = useSessionStorage("hasRevolution", false);
  const user = useUser();
  const gameState = useGameState();
  const lastTrick = gameState?.lastTurn.find((t) => t.type === "trick");
  useEffect(() => {
    if (!has && user?.uid === lastTrick?.player) {
      if (lastTrick?.__outcome?.isRevolution) {
        setHas(true);
      }
    }
  }, [lastTrick?._id]);
  return has;
}
